<mat-card class="offer-card" appearance="outlined" >
  <!--mat-card-header>
    <mat-card-title><mat-icon matListIcon>work_outline</mat-icon>Carga Empleados</mat-card-title>
  </mat-card-header-->
  <mat-card-content>

    <div class="file-upload-container">
      <input type="file" id="fileInput" (change)="onFileSelected($event)" hidden>

      <button mat-stroked-button color="primary" (click)="fileInput.click()" type="button">
        <mat-icon>attach_file</mat-icon> Seleccionar archivo
      </button>

      <span class="file-name" *ngIf="selectedFile">{{ selectedFile.name }}</span>
      <br>
      <button mat-raised-button color="accent" (click)="onUpload()" [disabled]="!selectedFile">
        <mat-icon>cloud_upload</mat-icon> Subir archivo
      </button>

      <input #fileInput type="file" (change)="onFileSelected($event)" hidden>
    </div>
  </mat-card-content>
</mat-card>